// Mock data for the commercial locksmith website

export const businessInfo = {
  name: "Shore Doors",
  tagline: "Installation & Delivery Partner",
  // The 09 landline is the published number (it diverts to the mobile); the
  // mobile stays listed as a second line on the contact page and footer.
  phone: "09 972 4640",
  phoneTel: "+6499724640",
  mobile: "022 513 3957",
  mobileTel: "+64225133957",
  email: "info@shoredoors.co.nz",
  address: "Auckland, New Zealand",
  enquiryMailto: "mailto:info@shoredoors.co.nz?subject=Enquiry%20%E2%80%93%20Shore%20Doors%20Website&body=Hi%20Shore%20Doors%2C%0A%0AI'd%20like%20to%20enquire%20about%20access%20control%20%2F%20locking%20hardware%20for%3A%0A%0ALocation%3A%0AProject%20type%3A%0ATimeline%3A%0A%0AMy%20name%3A%0AMy%20phone%20number%3A"
};

export const services = [
  {
    id: 1,
    title: "Mechanical Door Hardware Installation",
    description: "Reliable, code-compliant hardware installation for high-traffic commercial environments.",
    details: "We install and service commercial-grade mechanical door hardware built to withstand daily use in demanding environments. Our scope covers commercial mortice locks, cylinders, levers, and panic hardware—selected and installed for durability and compliance. We also handle fire door hardware installations to meet building code and insurance requirements. Whether it's a new fit-out or hardware replacement programme, our installations are built for long-term reliability and minimal callbacks.",
    icon: "Key",
    scope: ["Commercial mortice locks", "Cylinders, levers, panic hardware", "Fire door hardware installation"]
  },
  {
    id: 2,
    title: "Electronic Locking & Access Control Hardware",
    description: "Physical hardware installation for secure, managed entry points.",
    details: "We install the physical locking hardware that makes access control systems work—maglocks, electric strikes, drop bolts, electronic mortice locks, and wireless locks including Aperio. Our focus is on clean, compliant installations that integrate with the access control platform specified by your integrator. Every installation is built to support reliable day-to-day operation, with attention to power requirements, cable management, and future serviceability.",
    icon: "Lock",
    scope: ["Maglocks, electric strikes, drop bolts", "Electronic mortice locks, wireless locks (e.g., Aperio)", "Hardware installation for new and retrofit projects"]
  },
  {
    id: 3,
    title: "Cabling & Power for Access Control",
    description: "Low-voltage infrastructure to support reliable access control operation.",
    details: "Proper cabling and power supply are critical to system reliability. We run low-voltage cabling to doors, access points, and controllers, and install power supplies with battery backup where required. Our work includes full termination and labelling for easy ongoing maintenance. Whether you're commissioning a new system or upgrading existing infrastructure, we ensure the electrical backbone supports consistent, fault-free operation.",
    icon: "Zap",
    scope: ["Low-voltage cabling to doors and controllers", "Power supplies and battery backup", "Terminations and labelling"]
  },
  {
    id: 4,
    title: "Gate, Door & Passage Automation",
    description: "Automated entry installation for accessibility, traffic flow, and security.",
    details: "We install and service automated door and gate systems for commercial buildings, carparks, and secure perimeters. This includes swing door operators, sliding doors, and gate automation—all installed to work with access control where specified. Automation improves accessibility, manages traffic flow, and reduces wear on manual hardware. Our installations are designed for reliability and ease of maintenance in high-use commercial settings.",
    icon: "DoorOpen",
    scope: ["Swing door operators", "Sliding doors and gate automation", "Installation to work with specified access control systems"]
  },
  {
    id: 5,
    title: "Commissioning & Integration Support",
    description: "Connecting installed hardware to your access control platform with proper documentation.",
    details: "We work alongside your access control integrator or IT team to ensure all installed hardware communicates correctly with the management platform. Our scope includes physical integration support, full testing of each access point, and handover documentation covering installed hardware and configurations. Proper commissioning means fewer issues post-handover and a clear record for ongoing management.",
    icon: "Settings",
    scope: ["Integration support with your access control integrator", "Testing and commissioning of all access points", "Handover documentation and as-built records"]
  },
  {
    id: 6,
    title: "Maintenance, IQP Support & Remedials",
    description: "Ongoing hardware support delivered in collaboration with integrators and FM teams.",
    details: "We provide scheduled maintenance to keep door hardware and access control components operating reliably, working alongside your integrator and facilities management team. For buildings requiring IQP compliance, we support inspection and certification requirements for specified systems. We also handle remedial works on underperforming or failed hardware—whether that's replacing worn components, resolving access faults, or upgrading legacy equipment. Regular maintenance reduces downtime and extends asset life.",
    icon: "Wrench",
    scope: ["Scheduled preventive maintenance", "IQP compliance support and inspections", "Remedial works and hardware upgrades"]
  }
];

export const industries = [
  {
    id: 1,
    title: "Healthcare Facilities",
    description: "Door hardware and access control installation for hospitals, clinics, and aged care facilities.",
    image: "https://images.pexels.com/photos/668300/pexels-photo-668300.jpeg",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Data Centres",
    description: "High-security hardware installation for environments requiring multi-factor access and detailed audit trails.",
    image: "https://images.pexels.com/photos/5480781/pexels-photo-5480781.jpeg",
    icon: "Server"
  },
  {
    id: 3,
    title: "Educational Institutions",
    description: "Lock and access hardware installation for schools, universities, and libraries with complex zoning requirements.",
    image: "https://images.unsplash.com/photo-1586144131462-fa2a2b6d070c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBzY2hvb2wlMjBidWlsZGluZyUyMGVkdWNhdGlvbiUyMGZhY2lsaXR5fGVufDB8fHx8MTc3MTY2MTI1N3ww&ixlib=rb-4.1.0&q=85",
    icon: "GraduationCap"
  },
  {
    id: 4,
    title: "Government Buildings",
    description: "Compliant hardware installation for council buildings and public sector facilities.",
    image: "https://images.pexels.com/photos/34840277/pexels-photo-34840277.jpeg",
    icon: "Building2"
  },
  {
    id: 5,
    title: "Retirement Villages",
    description: "Door hardware for aged care communities balancing security with resident independence.",
    image: "https://images.unsplash.com/photo-1771154136777-44bc715a3bba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHx1cHNjYWxlJTIwaG90ZWwlMjBsb2JieSUyMGxvdW5nZSUyMGludGVyaW9yJTIwbW9kZXJuJTIwY29tZm9ydGFibGUlMjBzZWF0aW5nfGVufDB8fHx8MTc3MTY2NTQ4NHww&ixlib=rb-4.1.0&q=85",
    icon: "Home"
  },
  {
    id: 6,
    title: "Corporate Offices",
    description: "Hardware installation for commercial office buildings with tenant access and visitor management requirements.",
    image: "https://images.unsplash.com/photo-1641760378661-6f290a50a62d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBidWlsZGluZyUyMGJ1c2luZXNzfGVufDB8fHx8MTc3MTY2MTI2MHww&ixlib=rb-4.1.0&q=85",
    icon: "Building"
  }
];

// Gallery - placeholder for actual project photos when provided
export const gallery = [];

export const testimonials = [
  {
    id: 1,
    name: "Jason Wordsworth",
    title: "Security Contracts Manager",
    company: "Direct Control",
    quote: "Shore Doors is an invaluable service provider to the Direct Control security team. They are reliable and consistently deliver quality installations, and are a pleasure to work with.",
    logo: "/images/partners/direct-control.webp",
    logoBgDark: true,
    website: "https://www.directcontrol.nz/"
  },
  {
    id: 2,
    name: "Quinton Broad",
    title: "Managing Director",
    company: "Integrated Security Services",
    quote: "We use Shore Doors as an access control partner because their installs are to a high standard and they're easy to work with. They've helped us deliver a lot of projects over the past few years.",
    logo: "/images/partners/integrated-security.png",
    logoBgDark: false,
    website: "https://integratedsecurity.co.nz/"
  },
  {
    id: 3,
    name: "Tej Kumar",
    title: "Consultant",
    company: "Kumar Consulting",
    quote: "Nice and easy to deal with. Professional and good attention to detail on all the work Shore Doors done for us. Good turnaround times for urgent jobs too.",
    logo: "/images/partners/kumar-consulting.png",
    logoBgDark: false
  },
  {
    id: 4,
    name: "Reynardt Badenhorst",
    title: "Managing Director",
    company: "NZ Teco",
    quote: "Shore Doors' knowledge of hardware is broad, especially when it comes to electronic lock installations. We find their installs are a great way to showcase our products.",
    logo: "/images/partners/nz-teco.png",
    logoBgDark: true,
    website: "https://www.nzteco.co.nz/"
  },
  {
    id: 5,
    name: "Tristan Bailey",
    title: "Business Director",
    company: "Vision Systems",
    quote: "We have worked with Hugh and the Shoredoors team on multiple projects in the Auckland region. The team has always been on time and worked to a high professional standard!",
    logo: "/images/partners/vision-systems.webp",
    logoBgDark: true,
    website: "https://visionsystems.co.nz/"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What types of commercial projects do you work on?",
    answer: "We work on large-scale commercial installations including hospitals, data centres, schools, libraries, government buildings, retirement villages, and corporate offices. We regularly partner with access control integrators, builders, and facilities management teams on these projects, handling the physical installation and commissioning of door hardware and access control components."
  },
  {
    id: 2,
    question: "Do you provide ongoing maintenance and support?",
    answer: "Yes, we provide scheduled maintenance and IQP compliance support for door hardware and access control components, delivered in collaboration with your integrator and FM team. This includes preventive maintenance, remedial works, inspections, and hardware upgrades to maintain asset performance and compliance."
  },
  {
    id: 3,
    question: "Can you work alongside our existing access control integrator?",
    answer: "Absolutely. That's how we typically operate. We work alongside your access control integrator or IT team to install the physical locking hardware—locks, maglocks, electric strikes, drop bolts, cabling—while they handle readers, system programming and configuration. We're set up to support your project team, not replace them."
  },
  {
    id: 4,
    question: "What brands and technologies do you install?",
    answer: "We install a wide range of commercial hardware including Aperio wireless technology, electronic mortice locks, maglocks, electric strikes, and drop bolts. We install to the specifications provided by your integrator or project team, and can advise on hardware suitability where needed. Readers and system programming stay with your access control provider."
  },
  {
    id: 5,
    question: "How long does a typical installation take?",
    answer: "Project timelines vary based on scope and complexity. A small office fit-out might take 1-2 weeks, while a large hospital or multi-building campus could take several months. We work to your project programme and coordinate with other trades on site."
  },
  {
    id: 6,
    question: "Are your installations compliant with NZ building codes?",
    answer: "Yes, all our work fully complies with New Zealand building codes and fire safety regulations. We ensure proper emergency override capabilities and coordinate with building inspectors and fire safety officers as part of the installation process."
  },
  {
    id: 7,
    question: "Do you provide handover documentation?",
    answer: "Yes, we provide comprehensive handover documentation for all installations, including as-built records, hardware schedules, and configuration notes. This supports your integrator and FM team with ongoing system management."
  },
  {
    id: 8,
    question: "What's the warranty on your installations?",
    answer: "We provide a 12-month warranty on all installation workmanship, with manufacturer warranties applying to hardware components. Extended maintenance agreements are available for ongoing support."
  }
];

// Testimonials & Delivery Partners - placeholder for verified testimonials and partnerships when confirmed
export const partners = [];

// Stats - placeholder for verified statistics when confirmed
export const stats = [];
